export default {
	data(){
		return {
			pagination: {
				page: 1,
				pageSize: 10,
				total: 0,
				pages: 0
			}
		}
	}
}